import reduxCrud from 'redux-crud';

const passengersReducers = reduxCrud.Map.reducersFor('passengers', {
  key: 'id',
});

export default passengersReducers;
